// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// styles
import { PdpWrapper, PdpSection, PdpSectionTitle, FaqItem, FaqQuestion, FaqAnswer } from './styles';

// helpers
import { getValidFaqItems, ProductAeoFaqItem } from './helpers';

// constants
import { FAQ_TITLE } from './constants';

interface IProductAeoFaqProps {
  items?: ProductAeoFaqItem[];
}

function ProductAeoFaq({ items }: IProductAeoFaqProps) {
  const validItems = getValidFaqItems(items);
  if (isEmpty(validItems)) {
    return null;
  }

  return (
    <PdpWrapper className="AEO-pdp-wrapper" data-test="product-aeo-faq" data-at="product-aeo-faq">
      <PdpSection className="AEO-pdp-section">
        <PdpSectionTitle className="AEO-pdp-section-title">{FAQ_TITLE}</PdpSectionTitle>
        {validItems.map((item, index) => (
          <FaqItem className="AEO-pdp-faq-item" key={`product-aeo-faq-${index}`}>
            <FaqQuestion className="AEO-pdp-faq-question">
              Q{index + 1}: {item.que}
            </FaqQuestion>
            <FaqAnswer className="AEO-pdp-faq-answer">{item.ans}</FaqAnswer>
          </FaqItem>
        ))}
      </PdpSection>
    </PdpWrapper>
  );
}

export default memo(ProductAeoFaq);
